import axios from "axios";
import React from "react";
import { BsCheckLg } from "react-icons/bs";
import { GrEdit, GrView } from "react-icons/gr";
import AsyncSelect from "react-select/async";
import { debounce } from "lodash";

const customStyles = {
  control: (provided) => ({
    ...provided,
    textAlign: "left",
    border: "1.5px solid #bdc4d5",
    borderRadius: 10,
    boxShadow: "none",
  }),
};

export const Lead = ({ data, approveLead }) => {
  const [isEditingAddress, setIsEditingAddress] = React.useState(false);
  const [matchedProperty, setMatchedProperty] = React.useState({
    value: data.property.id,
    label: data.property.address,
  });

  const propertyEstimationUrl = `https://estimate.homeprice.co.nz/${data.property.id}`;

  const _loadAddressSuggestions = (inputValue, callback) => {
    if (!inputValue || inputValue.length < 3) {
      callback([]);
      return;
    }
    axios
      .get(
        `https://homes-api.disrupted.co.nz/properties/search?term=${inputValue}`
      )
      .then(({ data }) => {
        callback(data);
      });
  };

  const loadAddressSuggestions = debounce(_loadAddressSuggestions, 500);

  return (
    <React.Fragment>
      <div>{data.name}</div>
      <div>{data.address}</div>
      {isEditingAddress ? (
        <AsyncSelect
          cacheOptions
          onChange={(option) => setMatchedProperty(option)}
          loadOptions={loadAddressSuggestions}
          value={matchedProperty}
          defaultOptions
          hasError={!!matchedProperty}
          styles={customStyles}
        />
      ) : (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={propertyEstimationUrl}
        >
          {data.property.address}
        </a>
      )}
      <div className="flex">
        <BsCheckLg
          onClick={() =>
            approveLead.mutate({
              leadId: data.id,
              propertyId: matchedProperty.value,
            })
          }
          className="mx-1 cursor-pointer"
          size={20}
        />
        <GrEdit
          className="mx-1 cursor-pointer"
          size={20}
          onClick={() => {
            setIsEditingAddress((v) => !v);
          }}
          style={{
            display: isEditingAddress ? "none" : "block",
          }}
        />
        <GrView
          onClick={() => window.open(propertyEstimationUrl, "_blank")}
          className="mx-1 cursor-pointer"
          size={20}
        />
      </div>
    </React.Fragment>
  );
};
